import { useState } from "react";
import { SectionCard } from "../shared";
import { TermsEditor } from "../tabs";
import { FileSignature } from "lucide-react";


export default function AgreementInlineSection({ buyer }) {
  const [collapseSignal, setCollapseSignal] = useState(0);
  if (!buyer) return null;
  return (
    <SectionCard
      icon={FileSignature}
      title="Step 1 · Agreement"
      subtitle={`${buyer.company || buyer.name} — returns, shipping delays, damaged-orders, and shipping policy + signed contract. Claims auto-deduct from the daily invoice when a term is breached.`}
      testId="setup-section-agreement-inline"
      defaultOpen={false}
      forceCollapseSignal={collapseSignal}
    >
      <div className="p-5">
        <TermsEditor counterpartId={buyer.id} role="seller" onSaved={() => setCollapseSignal(s => s + 1)} />
      </div>
    </SectionCard>
  );
}
